import IDErrorPage from './IDErrorPage';

export default IDErrorPage;
